// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderWrapper_loader__39mJO","loaderAbsolute":"LoaderWrapper_loaderAbsolute__3k5xH","showLoader":"LoaderWrapper_showLoader__3rqR-","rotate":"LoaderWrapper_rotate__1Tvf4"};